import React, { useEffect, useMemo, useState } from "react";
import axiosInstancePcdo from "./pcdoAxiosInstance";
import { getLocalStorage, getParsedLocalStorage } from "../../Utils/storage-utils";
import { useImmer } from "use-immer";
import toast from "react-hot-toast";
import { isValidObject } from "../../Utils/Utils";
import PcdoComponent from "./PcdoComponent";
import Loader from "../Loader/Loader";

//LOGIN
//SAVE DATA in LOCAL
//FETCH ANNEXURE DATA
//SIDE bar

//https://192.168.1.214:40001/pcdo_api/user/login

const pcdoUserDataInit = getParsedLocalStorage("pcdo_user_data") ?? null;
const initUserData = {
  data: pcdoUserDataInit,
  isLoading: true,
};

const getUserGroupes = async (pcdo_user_id) => {
  const groupUrl = "/generic/table?name=group";
  axiosInstancePcdo.get(groupUrl).then((groupRes) => {
    localStorage.setItem("pcdo_user_groupes", JSON.stringify(groupRes.data));
  });
};

const ANNEXURE_LIST_URL = "/annexure";

const getAnnexureList = async () => {
  const url = ANNEXURE_LIST_URL;
  try {
    const response = await axiosInstancePcdo.get(url);
    const annexureList = response?.data ?? [];
    localStorage.setItem("pcdo_annexure_list", JSON.stringify(annexureList));
  } catch (err) {
    const errMsg = err?.message;
    throw new Error(errMsg);
  }
};
function PcdoWrapper() {
  const [userData, setUserData] = useImmer(initUserData);
  useEffect(async () => {
    if (!userData.data) {
      setUserData((prev) => {
        prev.isLoading = true;
        prev.data = null;
      });
      const app_user_id = getLocalStorage("userId");
      let body = {
        app_user_id: app_user_id,
      };
      try {
        const userRes = await axiosInstancePcdo.post("user/login", body);
        if (userRes.data) {
          localStorage.setItem("pcdo_user_data", JSON.stringify(userRes.data));

          await getUserGroupes(userRes.data.id);
          await getAnnexureList();
          setUserData((prev) => {
            prev.isLoading = false;
            prev.data = userRes.data;
          });
        } else {
          setUserData((prev) => {
            prev.isLoading = false;
            prev.data = null;
          });
          toast.error("User Info not found");
        }
      } catch (err) {
        setUserData((prev) => {
          prev.isLoading = false;
          prev.data = null;
        });
        toast.error(err.message);
      }
    } else {
      setUserData((prev) => {
        prev.isLoading = false;
      });
    }
  }, []);

  if (userData.isLoading) {
    return <Loader />;
  } else {
    if (isValidObject(userData.data)) {
      return <PcdoComponent />;
    } else {
      return <div>unable to show view</div>;
    }
  }

  //     return <div>
  // {userData.isLoading && }
  //     </div>;
}

export default PcdoWrapper;
